import React, { Component } from 'react';
import 'react-table/react-table.css';
import Pagination from '../component/Pagination.js';
import { InlineLoading } from './Loading.js';

function Row({ data, index, is_index = true }) {
  const dataArray = Object.values(data);
  return (
    <tr>
      {is_index ? <td>{index}</td> : ''}
      {dataArray.map((value, i) => {
        return <td key={i} style={{ maxWidth: 300, wordWrap: 'break-word', whiteSpace:'normal' }}>{value}</td>;
      })}
    </tr>
  );
}

export class Table extends Component {
  state = {
    currentPage: 1,
    from: 0
  };

  handlePageChange = pageNumber => {
    this.setState(prevState => {
      return {
        currentPage: pageNumber,
        from: (pageNumber - 1) * 10
      };
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ from: 0 });
    }
  }

  render() {
    const currentPage = this.state.currentPage;
    const {
      headers = [],
      pagination = true,
      aggregate,
      isLoading,
      listsPerPage = 10,
      isBordered = false,
      id = ''
    } = this.props;

    const datas = this.props.data ? this.props.data.length > 0
      ? this.props.data.map(this.props.columnMapper)
      : [] : [];
    const indexOfLastPost = this.state.currentPage * listsPerPage;
    const indexOfFirstPost = indexOfLastPost - listsPerPage;
    const currentLists = pagination
      ? datas
        ? datas.slice(indexOfFirstPost, indexOfLastPost)
        : []
      : datas;

    return (
      <div className='table-responsive'>
        <table
          className={`table align-items-center table-${
            isBordered ? 'bordered' : 'flush'
            } responsive`}
          id={id ? id : 'table'}
        >
          <thead className='thead-light'>
            <tr>
              {headers.map((header, i) => {
                return (
                  <th key={i} scope='col'  className='sort' style={{ minWidth: 20,maxWidth:300, wordWrap: 'break-word', whiteSpace:'normal' }}>
                    {header}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className='list'>
            {isLoading ? (
              <tr>
                <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                  <InlineLoading isLoading={isLoading} />
                </td>
              </tr>
            ) : currentLists.length > 0 ? (
              currentLists.map((currentList, i) => {
                return (
                  <Row
                    is_index={this.props.index}
                    key={i}
                    data={currentList}
                    index={this.state.from + i + 1}
                  />
                );
              })
            ) : (
                  <tr>
                    <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                      tidak ada data..
                </td>
                  </tr>
                )}
            {currentLists.length > 0 && aggregate ? (
              <tr>{aggregate(this.props.data)}</tr>
            ) : null}
          </tbody>
        </table>
        {pagination && !isLoading ? (
          <Pagination
            listsPerPage={listsPerPage}
            totalLists={datas && datas.length}
            handlePageChange={this.handlePageChange}
            currentPage={currentPage}
          />
        ) : (
            ''
          )}
      </div>
    );
  }
}

export default Table;
